import { createAction } from "@reduxjs/toolkit";

export const changeMode = createAction<string>("changeMode");
